import { render, staticRenderFns } from "./LoadingSpan.vue?vue&type=template&id=8811385a&scoped=true&"
import script from "./LoadingSpan.vue?vue&type=script&lang=js&"
export * from "./LoadingSpan.vue?vue&type=script&lang=js&"
import style0 from "./LoadingSpan.vue?vue&type=style&index=0&id=8811385a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8811385a",
  null
  
)

export default component.exports